export class ResponseDTO {

  constructor(
    readonly question: string,
    readonly value: any
  ) {
  }
}